import { render } from "./Cohort.vue?vue&type=template&id=274d6594&scoped=true&ts=true"
import script from "./Cohort.vue?vue&type=script&lang=ts"
export * from "./Cohort.vue?vue&type=script&lang=ts"

import "./Cohort.vue?vue&type=style&index=0&id=274d6594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274d6594"]])

export default __exports__